export default __webpack_public_path__ + "static/playStore-dc427feb09bb517d950001a0c22166d7.svg";